(async () => {
    const { Core } = await importModule('Core');

    customElements.define('product-form', class extends Core {

        elements = {
            form: '[data-to-cart-form]',
            toCartButton: 'product-to-cart'
        }

        subscriptions = {
            'cart:update':  '_cartUpdateHandler',
            'cart:error':  '_cartUpdateHandler'
        }

        render() {
            this.subscribe('cart:update', { global: true });
            this.subscribe('cart:error', { global: true });
            this.$form?.addEventListener('submit', this._submitHandler.bind(this));
            var originalSelect = this.closest(".shopify-section").querySelector("[name='quantity']");
            if(originalSelect){
            if(document.querySelector("[product-sticky-button-qty]")){
              document.querySelector("[product-sticky-button-qty]").addEventListener("change", function(){
                  originalSelect.value = this.value;
              });
               originalSelect.addEventListener("change", function(){
                   document.querySelector("[product-sticky-button-qty]").value = this.value;
              });
            }
            }
        }

        _submitHandler(e) {
            e.preventDefault();
            if (this._inFlight) return;
            this._inFlight = true;
            this._publishBuyWithPreview();
            this.$toCartButton.addToCart(this.cartItems, this.mainVariantId)
        }

        _publishBuyWithPreview() {
            const previews = [];
            for (const [name, value] of this.formData.entries()) {
                if (!name.startsWith('buy_with_')) continue;
                const checkbox = document.querySelector(`product-buy-with input[name="${name}"][value="${value}"]`);
                const el = checkbox?.closest('product-buy-with');
                if (!el) continue;
                previews.push({
                    image: el.dataset.buyWithImage,
                    url: el.dataset.buyWithUrl,
                    title: el.dataset.buyWithTitle,
                    isPreview: true
                });
            }
            if (previews.length) {
                this.publish('cart-notification:preview-add', { items: previews });
            }
        }

        _cartUpdateHandler() {
            this._inFlight = false;
        }

        _isVariantInput([ inputName, value ]) {
            if (inputName === 'selling_plan') this._setSellingPlan(value);
            return inputName === 'id';
        }

        _setSellingPlan(id) {
            this.sellingPlanId = id;
        }

        _setCartItem([ inputName, value ]) {
            if (inputName === 'id') this.mainVariantId = value;
            const sellingPlanId = this.sellingPlanId || '';

            const isPreorder = this.$toCartButton?.isPreorder;
            const preorderMessage = this.$toCartButton?.preorderMessage || 'Ships in 4-6 Weeks';

            const item = {
                id: value,
                quantity: this._getItemQty(inputName),
                selling_plan: inputName === 'id' ? sellingPlanId : ''
            };
            if (inputName === 'id' && isPreorder) {
                item.properties = { 'Shipping': preorderMessage };
            }
            return item;
        }

        _getItemQty(inputName) {
            return inputName === 'id' ? this.qty : 1;
        }

        get cartItems() {
            return Array.from(this.formData.entries())
                .filter(this._isVariantInput.bind(this))
                .map(this._setCartItem.bind(this))
        }

        get formData() {
            return new FormData(this.$form);
        }

        get qty() {
            return +this.formData.get('quantity') || 1;
        }
    })
})();